const makeMediaQuery = (size, type, styles) => `
  @media (${type}-width: ${size - (type === "max" ? 1 : 0)}px) {
    ${styles}
  }
`

export default makeMediaQuery
